@if (taxFormGroup) {
<div class="flex flex-col gap-y-10" [formGroup]="taxFormGroup">
  <div class="flex flex-row gap-x-10 items-stretch">
    <div class="flex flex-col gap-y-5 w-full">
      <div>
        <label for="federal-tax-amount" class="text-base text-gray-dark font-bold" for="federalTaxAmount">Federal Tax</label>
        <mat-icon class="mi-20 text-mint-dark pl-5" svgIcon="information" matTooltip="
          This data is provided in real-time by Charles Schwab"
            matTooltipPosition="after"
            matTooltipClass="text-sm border rounded-t rounded-b border-mint-lighter bg-mint-lightest text-gray-dark">
        </mat-icon>
      </div>     
      <label class="text-sm text-gray">CURRENT: {{ (fedTaxClone | number : '1.2-2') ?? '0.00' }}%</label>
      <input id="federal-tax-amount" currencyMask [options]="federalTaxMaskOptions" type="text" onfocus="this.select()"           
        class="w-full input text-base text-gray-dark" formControlName="federalTaxAmount" placeholder="0.00%" />
    </div>
    <div class="flex flex-col gap-y-5 w-full">
      <div>
         <label for="state-tax-amount" class="text-base text-gray-dark font-bold" for="stateTaxAmount">State Tax</label>
        <mat-icon class="mi-20 text-mint-dark pl-5" svgIcon="information" matTooltip="
          This data is provided in real-time by Charles Schwab"
            matTooltipPosition="after"
            matTooltipClass="text-sm border rounded-t rounded-b border-mint-lighter bg-mint-lightest text-gray-dark">
        </mat-icon>
      </div>          
      <label class="text-sm text-gray">CURRENT: {{ (stateTaxClone | number : '1.2-2') ?? '0.00' }}%</label>
      <input id="state-tax-amount" currencyMask [options]="stateTaxMaskOptions" type="text" onfocus="this.select()"        
        class="input text-base text-gray-dark" formControlName="stateTaxAmount" placeholder="0.00%" />
    </div>    
  </div>
  @if (taxFormGroup.value.isTaxWithholdingsChanged === true){  
  <!-- <app-message-notification panelType="alert" [showPanelIcon]=false>
      <div>
        <strong>Please Note</strong>, if you are changing withholding elections, they will remain in effect on all
        distributions for this account until you change or revoke it.
      </div>    
    </app-message-notification> -->
    <div class="flex items-center text-sm text-orange">
      <div>
        <strong>Please Note</strong>, if you are changing withholding elections, they will remain in effect on all
        distributions for this account until you change or revoke it.
      </div>    
    </div>
  }
</div>
}